import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { matchRoutes, renderRoutes, withRouter } from 'mage-react-router';
import { isOverseas } from '@moka-fe/ats.utils';
import { Button, Loading, Modal, Spacing } from 'sugar-design';

import AutoReload from '@/components/common/AutoReload';
import ChangePassword from '@/components/common/ChangePassword';
import SecretModal from '@/components/common/SecretModal';
import TextLogo from '@/components/common/TextLogo';
import UserTab from '@/components/common/UserTab';
import Warning from '@/components/common/Warning/Warning';
import PcPolicyPreviewModal from '@/components/privacy/PcPolicyPreviewModal';
import Footer from './[orgId]/_lib/Footer';
import HeadhunterLogin from './[orgId]/_lib/HeadhunterLogin';

import { PRIVACY_SCOPE_FIELD_NEW } from '@/components/privacy/constants';
import { getPrivacySettingByType } from '@/components/privacy/service';
import { ACCOUNT_TYPES, LS_SHOW_SECRET_POLICY, isDingtalk } from '@/constants/common';
import { clearApplicationInfo, fetchExcelApplicationStats } from '@/redux/actions/applications';
import { fetchJobList, fetchRelatedJobs } from '@/redux/actions/jobs';
// 不想在headhunter引用main-app的组件，无奈妥协。
import { login, newLogin, switchLocale, updatePassword } from '@/redux/actions/me';
import {
  fetchOrg,
  fetchOrgList,
  getHeadhunterApplyForm,
  getHeadhunterSetting,
  getOverseasNumber,
  getSecretPolicy,
  setSecretPolicy,
} from '@/redux/actions/org';
import { getLocalStorage, setLocalStorage } from '@/utils/common';
import { getI18n } from '@/utils/i18n';

import logoDingtalk from '@/static/images/logoDingtalk.png';
import logoHorizontalSvg from '@/static/images/logoHorizontal.svg';

const i18n = getI18n();

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPasswordDialog: false,
      showSecretModal: false,
      showSecretTip: false,
      needCaptcha: false, // 是否需要图形验证
      captchaValidateValue: '', // 图形验证码通过码
      showError: false, // 是否展示错误信息

      policyList: [],
      showPrivacyModal: false,
      currentOrgId: '',

      isReloadModalOpen: false,
      reloadModalCanCancel: true,
    };

    this.onShowPasswordDialog = () => this.setState({ showPasswordDialog: true });
    this.onHidePasswordDialog = () => this.setState({ showPasswordDialog: false });
  }

  UNSAFE_componentWillMount() {
    if (this.props.me.loggedIn) {
      this.getSecret();
      this.props.fetchOrgList();
      const { orgId } = this.props.match.params || {};
      window?.localStorage?.setItem('headHunter_orgId', orgId);

      if (orgId) {
        this.props.fetchOrg(orgId);
        this.props.fetchJobList(orgId);
        this.props.fetchRelatedJobs(orgId);
        this.props.fetchExcelApplicationStats(orgId);
        this.props.getHeadhunterSetting(orgId);
        this.props.getHeadhunterApplyForm(orgId);
        this.props.getOverseasNumber(orgId);
      }
    }
  }

  getSecret = () => {
    getSecretPolicy().then(({ agreement } = {}) => {
      this.setState({
        showSecretTip: !agreement,
      });
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { orgId } = nextProps.match.params;

    if (nextProps.me.loggedIn && !this.props.me.loggedIn) {
      this.props.fetchOrgList();
      if (orgId) {
        this.props.fetchOrg(orgId);
        this.props.fetchJobList(orgId);
        this.props.fetchRelatedJobs(orgId);
        this.props.fetchExcelApplicationStats(orgId);
        this.props.getHeadhunterSetting(orgId);
        this.props.getHeadhunterApplyForm(orgId);
        this.props.getOverseasNumber(orgId);
      }
    }

    if (orgId && orgId !== this.props.match.params.orgId) {
      this.props.fetchOrg(orgId);
      this.props.fetchJobList(orgId);
      this.props.fetchRelatedJobs(orgId);
      this.props.fetchExcelApplicationStats(orgId);
      this.props.getHeadhunterSetting(orgId);
      this.props.getHeadhunterApplyForm(orgId);
      this.props.getOverseasNumber(orgId);
      // 清除属于old orgId的数据
      this.props.clearApplicationInfo();
    }
  }
  componentDidMount() {
    /*
     *解决语言不生效的问题，猎头的login请求是个ajax请求，对ajax请求做redirect不会触发页面重新加载
     *前端登录后reload一下
     *通过中间态控制隐私说明的逻辑
     * */
    const showSecretPolicy = getLocalStorage(LS_SHOW_SECRET_POLICY, false);
    if (showSecretPolicy) {
      this.getSecret();
      setLocalStorage(LS_SHOW_SECRET_POLICY, false);
    }
  }

  onShowSecretModal = () => {
    this.setState({ showSecretModal: true });
  };
  onSecretConfirm = () => {
    this.props.setSecretPolicy(true).then(() => {
      this.setState({ showSecretModal: false, showSecretTip: false });
    });
  };

  createOrgLink(orgId) {
    return orgId ? `/headhunters/${orgId}/org/jobs` : '/headhunters/';
  }

  setNECaptchaValidate = (value) => {
    this.setState({
      captchaValidateValue: value,
      needCaptcha: false,
      showError: false,
    });
  };

  onLogin = ({ email, pwd }) => {
    const { captchaValidateValue } = this.state;
    if (!captchaValidateValue) {
      return this.setState({
        needCaptcha: true,
      });
    }
    this.props.newLogin(
      { email, pwd, captcha: captchaValidateValue },
      () => {
        window.location.reload();
      },
      () => {
        this.setState({
          captchaValidateValue: '',
          showError: true,
        });
      }
    );
  };

  enterOrgPage = (orgId) => {
    const link = this.createOrgLink(orgId);
    window.location.href = window.location.origin + link;
  };

  onOrgListClick = (org) => {
    if (org.selectOrgPopPrivacy) {
      getPrivacySettingByType(org.id, PRIVACY_SCOPE_FIELD_NEW.HEADHUNTER_SELECTION_COMPANY)
        .then((data) => {
          if (data.length > 0) {
            this.setState({
              showPrivacyModal: true,
              policyList: data,
              currentOrgId: org.id,
            });
          } else {
            this.enterOrgPage(org.id);
          }
        })
        .catch(() => {
          this.enterOrgPage(org.id);
        });
    } else {
      this.enterOrgPage(org.id);
    }
  };

  setReloadModalOpen = (forceRefresh) => {
    const { me, route, location } = this.props;
    const branch = matchRoutes(route.routes, location.pathname);
    // 如果已登录，并且匹配到子路由
    if (me.loggedIn && branch.length && route.routes) {
      this.setState({
        isReloadModalOpen: true,
        reloadModalCanCancel: !forceRefresh,
      });
    }
  };

  setReloadModalClose = () => {
    this.setState({ isReloadModalOpen: false, reloadModalCanCancel: true });
  };

  render() {
    const {
      showPrivacyModal,
      policyList,
      showPasswordDialog,
      showSecretModal,
      showSecretTip,
      needCaptcha,
      showError,
      currentOrgId,
      isReloadModalOpen,
      reloadModalCanCancel,
    } = this.state;
    const { me, orgEntities, loading, route, location } = this.props;
    const orgList = Object.keys(orgEntities).map((key) => orgEntities[key]);

    const Nav = (
      <div className="topbar">
        <Warning
          info={{}}
          pathname=""
          lagouAccounts={[]}
          browserNotificationEnabled={false}
          currentUser={me}
          accountType={ACCOUNT_TYPES.HEADHUNTER}
          onShowPasswordDialog={this.onShowPasswordDialog}
        />
        <img className="topbar__logo--moka" src={isDingtalk ? logoDingtalk : logoHorizontalSvg} />

        <UserTab
          currentUserEmail={me.email}
          onShowPasswordDialog={this.onShowPasswordDialog}
          switchLocale={this.props.switchLocale}
        />
      </div>
    );

    const OrgList = orgList && (
      <div className="orglist-panel">
        <p className="orglist-panel__title">{i18n.t`欢迎使用Moka，请选择服务公司`}</p>
        {orgList.length === 0 ? (
          <div className="orglist-panel--empty">{i18n.t`尚无服务的公司`}</div>
        ) : (
          <div className="orglist-panel__content">
            {/* organization list */}
            <Spacing className="orglist-panel__list" direction="vertical" spacing="lg" stretched>
              {orgList.map((item, idx) => (
                <div className="orglist-panel__list-item" key={`org-${idx}`}>
                  <div onClick={() => this.onOrgListClick(item)} className="orglist-panel__link">
                    <div className="orglist-panel__org-logo">
                      {item.logo ? <img src={item.logo} /> : <TextLogo text={item.name} />}
                    </div>
                    <span>{item.name}</span>

                    <div className="orglist-panel__amount">
                      <span className="orglist-panel__amount-num">{item.applicationNum}</span>
                      <span className="orglist-panel__amount-name">{i18n.t`已推荐候选人`}</span>
                    </div>
                    <div className="orglist-panel__amount">
                      <span className="orglist-panel__amount-num">
                        {item.jobNum + item.jobSpecNum}
                      </span>
                      <span className="orglist-panel__amount-name">{i18n.t`招聘职位`}</span>
                    </div>
                  </div>
                </div>
              ))}
            </Spacing>
          </div>
        )}
      </div>
    );

    // 是否匹配子路由
    const branch = matchRoutes(route.routes, location.pathname);

    const Content =
      me.loggedIn && (branch.length && route.routes ? renderRoutes(route.routes) : OrgList);

    return (
      <div>
        {me?.loggedIn && showSecretModal && (
          <SecretModal
            className="secret-modal"
            canClose={true}
            onClose={() => {
              this.setState({ showSecretModal: false });
            }}
          />
        )}

        {/* nav or login page */}
        {me.loggedIn ? (
          Nav
        ) : (
          <HeadhunterLogin
            me={me}
            needCaptcha={needCaptcha}
            showError={showError}
            login={this.onLogin}
            setNECaptchaValidate={this.setNECaptchaValidate}
          />
        )}

        {/* Content */}
        <div className="main">
          <div className="main-content">
            {loading && (
              <div className="panel--empty">
                <Loading />
              </div>
            )}
            <div className={loading ? 'hidden' : ''}>{Content}</div>
          </div>
          {/* Footer */}
          {!isOverseas && <Footer />}
        </div>
        {showSecretTip && (
          <div className="secret-footer">
            {i18n.t`继续使用此网站，表明您同意我们的`}
            <Button type="text" onClick={this.onShowSecretModal}>
              {i18n.t`《Moka隐私政策》`}
            </Button>
            <Button
              type="tertiaryDark"
              className="secret-footer-sure"
              onClick={this.onSecretConfirm}
            >
              {i18n.t`好的`}
            </Button>
          </div>
        )}
        {showPrivacyModal && (
          <PcPolicyPreviewModal
            isOpen={showPrivacyModal}
            privacyPolicy={policyList}
            onClose={() => this.setState({ showPrivacyModal: false })}
            onAgree={() => this.enterOrgPage(currentOrgId)}
          />
        )}
        {/* change password dialog */}
        <ChangePassword
          isOpen={showPasswordDialog}
          onCancel={this.onHidePasswordDialog}
          updatePassword={this.props.updatePassword}
        />
        <AutoReload
          url="/api/public/version"
          client={AutoReload.CLIENT_NAME.HEADHUNTER}
          onVersionChange={this.setReloadModalOpen}
        />

        <Modal
          isOpen={isReloadModalOpen}
          title={i18n.t`功能更新`}
          confirmText={i18n.t`刷新`}
          cancelText={i18n.t`稍后手动刷新`}
          onConfirm={() => window.location.reload()}
          onClose={this.setReloadModalClose}
          canCancel={reloadModalCanCancel}
          canClose={reloadModalCanCancel}
          canCloseOnClickMask={reloadModalCanCancel}
          canCloseOnEsc={reloadModalCanCancel}
          size="sm"
        >
          {i18n.t`系统功能已更新，为保证你后续正常使用，请点击刷新页面，或者稍后手动在浏览器中手动刷新页面`}
        </Modal>
      </div>
    );
  }
}

App.propTypes = {
  loading: PropTypes.bool,
  me: PropTypes.object,
  orgEntities: PropTypes.object,
  newLogin: PropTypes.func,
  fetchOrgList: PropTypes.func,
  fetchOrg: PropTypes.func,
  fetchJobList: PropTypes.func,
  fetchExcelApplicationStats: PropTypes.func.isRequired,
  updatePassword: PropTypes.func,
  switchLocale: PropTypes.func,
};

function mapStateToProps(state) {
  const initialData = window.Moka.data;
  const me = Object.assign(
    {
      loggedIn: initialData.loggedIn,
      email: initialData.email,
      id: initialData.id,
      passwordLevel: initialData.passwordLevel,
    },
    state.me
  );
  return {
    me,
    orgEntities: state.org.entities,
    loading: me.loggedIn && state.org.listLoading,
  };
}

export default connect(mapStateToProps, {
  login,
  newLogin,
  fetchOrgList,
  fetchOrg,
  fetchJobList,
  fetchRelatedJobs,
  fetchExcelApplicationStats,
  updatePassword,
  switchLocale,
  clearApplicationInfo,
  setSecretPolicy,
  getHeadhunterSetting,
  getHeadhunterApplyForm,
  getOverseasNumber,
})(withRouter(App));
